<i18n>
{
"en": {
  "FIRSTNAME(ARABIC)": "First Name (Arabic)",
  "FATHERNAME": "Father Name",
  "FATHERNAME(ARABIC)": "Father Name (Arabic)",
  "LASTNAME(ARABIC)": "Last Name (Arabic)",
  "NATIONALITY": "Nationality",
  "DATEOFBIRTH": "Date of Birth",  
  "STUDENTS": "Students",
  "MANAGESTUDENTS": "Manage Students",
  "CHOOSEFILERBY": "Choose Filer By",
  "NAME": "Name",
  "STATUS": "Status",
  "GRADE": "Grade",
  "CLASS": "Class",
  "ADDNEWSTUDENT": "Add New Student",
  "FIRSTNAME": "First Name",
  "LASTNAME": "Last Name",
  "IDCARD": "ID Card",
  "PRINTCARDS": "Print Cards",
  "ACTIVE": "Active",
  "INACTIVE": "Inactive",
  "MARKABSENCE": "Mark Absence",
  "SENDMESSAGE": "Send Message",
  "EDITSTUDENT": "Edit Student",
  "ISSUEATTENDANCETAG": "Issue Attendance Tag",
  "DEACTIVATESTUDENT": "Deactivate Student",
  "CANCEL": "Cancel",
  "UPLOADCSVFILE": "Upload CSV File",
  "AREYOUSUREYOUWANTTO": "Are you sure you want to",
  "RESTORETHISSTUDENT": "restore this student?",
  "DEACTIVATETHISSTUDENT": "deactivate this student?",
  "PRINTALLCARDS": "Print All Cards",
  "CHECKTAGID": "Check Tag ID",
  "SEARCHSTUDENTNAME": "Search student name",
  "SEARCHSTUDENTID": "Search student id",
  "FILTERBYROUTE": "Filter by route",
  "FILTERBYGRADE": "Filter by grade",
  "FILTERBYCLASS": "Filter by class",
  "FILTERBYSTATUS": "Filter by status",
  "LOADING": "Loading...",
  "STUDENTID": "Student ID",
  "ROUTENAME": "Route Name",
  "ACTIVATESTUDENT": "Activate Student",
  "CONFIRM": "Confirm",
  "STUDENTIDCARD": "Student ID Card",
  "SCHOOLCONTACT": "School Contact",
  "PRINT": "Print",
  "STUDENTHASBEENASSIGNEDTOROUTE": "Student has been assigned to route",
  "STUDENTHASNOGUARDIAN": "Student has no guardian",
  "STUDENTNAME": "Student Name",
  "AREA": "Area",
  "ZONE": "Zone",
  "SECTOR": "Sector",
  "CITY": "City",
  "STATE": "State",
  "ZIPCODE": "Zip Code",
  "LAT": "Latitude",
  "LNG": "Longitude",
  "SET": "Set",
  "HOUSENUMBER": "House Number",
  "GENDER": "Gender",
  "ADDRESS": "Address",
  "STUDENTHASBEEN": "Student has been",
  "RESTORED": "restored!",
  "DEACTIVATED": "deactivated!",
  "STUDENTCANNOTBEENDELETED": "Student cannot been deleted!",
  "ASSIGNEDTOBUS": "Assigned to bus",
  "ASSIGNED": "Assigned",
  "NOTASSIGNED":"Not assigned"
},
"ar": {
  "FIRSTNAME(ARABIC)": "الاسم الأول (عربي) ",
  "FATHERNAME": "اسم الاب",
  "FATHERNAME(ARABIC)": "اسم الأب (عربي) ",
  "LASTNAME(ARABIC)": " الاسم العائلي (عربي) ",
  "NATIONALITY": "الجنسية",
  "DATEOFBIRTH": "تاريخ الميلاد",
  "STUDENTS":"الطلاب",
  "MANAGESTUDENTS": "ادارة الطلاب",
  "CHOOSEFILERBY": "اختر الفلتر المطلوب",
  "NAME": "الاسم",
  "STATUS": "الحالة",
  "GRADE": "الدرجة",
  "CLASS": "الصف",
  "ADDNEWSTUDENT": "اضافة طالب جديد",
  "FIRSTNAME": "الأسم الأول",
  "LASTNAME": "اسم العائلة",
  "IDCARD": "بطاقة التعريف",
  "PRINTCARDS": " طبع البطاقات ",
  "ACTIVE": "مفعل",
  "INACTIVE": "غير مفعل",
  "MARKABSENCE": "تسجيل الغياب", 
  "SENDMESSAGE": " إرسال رسالة",
  "EDITSTUDENT": "تحرير الطالب",
  "ISSUEATTENDANCETAG": "إصدار بطاقة الحضور ",
  "DEACTIVATESTUDENT": "إيقاف التفعيل",
  "CANCEL": "الغاء",
  "UPLOADCSVFILE": "تحميل ملف CSV",
  "AREYOUSUREYOUWANTTO": "هل أنت متأكد أنك تريد",
  "RESTORETHISSTUDENT": " استعد هذا الطالب",
  "DEACTIVATETHISSTUDENT": "تعطيل هذا الطالب",
  "PRINTALLCARDS": " طباعة جميع البطاقات ",
  "CHECKTAGID": "التحقق من الشارة",
  "SEARCHSTUDENTNAME": " ابحث عن اسم الطالب",
  "SEARCHSTUDENTID": " ابحث عن رقم الطالب",
  "FILTERBYROUTE": "اختر حسب خط السير",
  "FILTERBYGRADE": " اختر حسب الدرجة",
  "FILTERBYCLASS": "اختر حسب الصف",
  "FILTERBYSTATUS": " اختر حسب الحالة",
  "LOADING": "جار التحميل...",
  "STUDENTID": " هوية الطالب",
  "ROUTENAME": "اسم المسار",
  "ACTIVATESTUDENT": " تفعيل الطالب",
  "CONFIRM": " تاكيد ",
  "STUDENTIDCARD": " بطاقة هوية الطالب",
  "SCHOOLCONTACT": " الاتصال بالمدرسة",
  "PRINT": " طبع",
  "STUDENTHASBEENASSIGNEDTOROUTE": " تم تعيين الطالب إلى الطريق",
  "STUDENTHASNOGUARDIAN": "ليس لطالب ولي أمر",
  "STUDENTNAME": " أسم الطالب",
  "AREA": " المنطقة",
  "ZONE": "الحوض",
  "SECTOR": "القسم",
  "CITY": "المدينة",
  "STATE": "الامارة",
  "ZIPCODE": "الرمز البريدي",
  "LAT": "الخط العامودي",
  "LNG": "الخط الطولي",
  "SET": "تثبيت",
  "HOUSENUMBER": "رقم المنزل",
  "GENDER": "الجنس",
  "ADDRESS": " العنوان",
  "STUDENTHASBEEN": "كان الطالب",
  "RESTORED": "رمم!",
  "DEACTIVATED": "معطلة!",
  "STUDENTCANNOTBEENDELETED": "لا يمكن حذف الطالب!",
  "ASSIGNEDTOBUS": "مشارك في الحافلة",
  "ASSIGNED": "مشارك",
  "NOTASSIGNED":"غيرمشارك"
}
}
</i18n>

<template>
  <div id="student-list">
    <el-card  class="card-border" ref="card" :body-style="{ padding: 0 }">
      <div slot="header" class="clearfix">
        <span style="line-height: 36px;" class="title">{{ $t("MANAGESTUDENTS") }}</span>
             <el-button-group v-if="selectedStudents.length!=0">
               <el-button type="primary" icon="close" @click="selectedStudents=[]"></el-button>
                 <el-button @click="printCard"><i class="fa fa-print"></i> {{ $t("PRINTCARDS") }} (<span v-text="selectedStudents.length"></span>)</el-button>
             </el-button-group>
            <el-dropdown v-else trigger="click" type="dark" @command="handleClick">
              <el-button-group>
                <el-button @click="newStudent" :disabled="!isAllowed('save')">
                  <i class="el-icon-plus"></i> {{$t('ADDNEWSTUDENT')}}
                </el-button>
                <el-button ref="trigger" class="el-dropdown__caret-button">
                  <i class="el-dropdown__icon el-icon-caret-bottom"></i>
                </el-button>
              </el-button-group>              
              <el-dropdown-menu id="student" slot="dropdown">
              <el-dropdown-item :disabled="!isAllowed('import')">       
              <el-upload
                ref="upload"
                accept=".csv"                
                class="upload-demo"
                :action="URL + 'media/upload'"
                :data="import_data"
                :with-credentials="true"
                :headers="{'Accept-Language': currentLang(), 'X-API-KEY': API_KEY}"
                :on-success="uploadedFile">
                <i class="fa fa-upload"></i> {{ $t("UPLOADCSVFILE") }}
              </el-upload>   
              </el-dropdown-item>
              <el-dropdown-item command="print"><i class="fa fa-print"></i> {{ $t("PRINTALLCARDS") }}</el-dropdown-item>
              <el-dropdown-item :disabled="!isAllowed('save_tag')" command="tag"><i class="fa fa-wifi"></i> {{ $t("CHECKTAGID") }}</el-dropdown-item>
            </el-dropdown-menu>
            </el-dropdown>
      </div>

      <div class="filters" ref="filter">
   
        <el-row :gutter="20">
          <el-col :span="4">
            <el-select  v-model="filter"  @change="changedFilter" :placeholder="$t('CHOOSEFILERBY')">
              <el-option
                v-if="item.value!=active_filter"
                :key="index" v-for="(item, index) in options"
                :label="item.label"
                :value="item.value">
              </el-option>
            </el-select>

         
           </el-col>


          <el-col :span="4" v-if="active_filter=='name'">
               <el-input v-model="FullName" @change="getStudents(true)" :placeholder="$t('SEARCHSTUDENTNAME')"  :icon="FullName ? 'circle-close' : ''" @click="clearInput"></el-input>
           </el-col>

            <el-col :span="4" v-if="active_filter=='id'">
               <el-input v-model="ExternalStudentID" @change="getStudents(true)" :placeholder="$t('SEARCHSTUDENTID')"  :icon="ExternalStudentID ? 'circle-close' : ''" @click="clearInput"></el-input>
           </el-col>

         <el-col :span="4"  v-if="active_filter=='route'">
             <el-select :disabled="loading" v-model="RouteID" :placeholder="$t('FILTERBYROUTE')" clearable  @change="getStudents(true)" filterable
             >
              <el-option
                :key="index" v-for="(item, index) in routes"
                :label="item.TourName"
                :value="item.TourID">
              </el-option>
            </el-select>       
           </el-col>
         <el-col :span="4"  v-if="active_filter=='grade'">
             <el-select :disabled="loading" value-key="GradeID" v-model="Grade" :placeholder="$t('FILTERBYGRADE')" clearable  @change="getStudents(true)">
              <el-option
                :key="index" v-for="(item, index) in grades"
                :label="item.Name"
                :value="item">
              </el-option>
            </el-select>       
           </el-col>

           <el-col :span="4"  v-if="Grade.Classes!=undefined && active_filter=='grade'">
             <el-select :disabled="loading" @change="getStudents(true)" v-model="gradeClass" :placeholder="$t('FILTERBYCLASS')" clearable>
              <el-option
                :key="index" v-for="(item, index) in Grade.Classes"
                :label="item"
                :value="item">
              </el-option>
            </el-select>         
           </el-col>

          <el-col :span="4"  v-if="active_filter=='status'">
             <el-select :disabled="loading"  v-model="Status" @change="getStudents(true)" :placeholder="$t('FILTERBYSTATUS')" clearable>
              <el-option :label="$t('ACTIVE')" value="1">
                <el-tag
                 type="success"
                close-transition>{{$t('ACTIVE')}}</el-tag>
              </el-option>
               <el-option  :label="$t('INACTIVE')" value="2">
                <el-tag
                 type="danger"
                close-transition>{{$t('INACTIVE')}}</el-tag>
              </el-option>
            </el-select>           
           </el-col>
          </el-row>
      </div>

          <el-table
           :element-loading-text="$t('LOADING')"
           v-loading="new_page || loading"
          :data="listStudents"
          highlight-current-row
          :height="tableHeight"
          stripe
          style="width: 100%">

          <el-table-column
            prop="ExternalStudentID"
            :label="$t('STUDENTID')"
            min-width="150"
            class="center"
            align="left"
            sortable>
          </el-table-column>
            <el-table-column
              :label="$t('NAME')"
              min-width="200"
              prop="FullName_EN"
              align="left"
              sortable
            >
              <template slot-scope="scope">
                <img :src="getAsset(scope.row.ImagePath)" alt="" class="img-circle">
                {{_FullName({NameEN: scope.row.FullName_EN, NameAR: scope.row.FullName_AR})}}
          </template>
            </el-table-column>
                 <el-table-column
            prop="Grade"
            :label="$t('GRADE')"
            min-width="100"
            align="center"
            sortable>
          </el-table-column>
          <el-table-column
            prop="Class"
            :label="$t('CLASS')"
            min-width="100"
            align="center"
            sortable>
          </el-table-column>

          <el-table-column
            prop="Status"
            :label="$t('STATUS')"
            min-width="100"
            align="center"
            sortable>
            <template slot-scope="scope">
              <el-tag
                :type="parseInt(scope.row.Status) !== 1  ? 'success' : 'danger'"
                close-transition>{{parseInt(scope.row.Status) !== 1 ? $t('ACTIVE') : $t('INACTIVE')}}</el-tag>
            </template>
          </el-table-column>

         <el-table-column
            prop="AssignmentStatus"
            :label="$t('ASSIGNEDTOBUS')"
            min-width="160"
            align="center"
            sortable>
            <template slot-scope="scope">
              <el-tag
                type="primary"
                close-transition>{{scope.row.AssignmentStatus !== null ? $t('ASSIGNED') : $t('NOTASSIGNED')}}</el-tag>
            </template>
          </el-table-column>

          <el-table-column align="center" min-width="140">
              <template slot-scope="scope">
                  <el-button-group >
                      <el-button  size="small" :type="isOnQueue(scope.row)  ? 'primary' : ''" @click="printQueue(scope.row)"><i :class="[ isOnQueue(scope.row)  ? 'fa fa-check-square' : 'fa fa-square-o']"></i></el-button>
                      <el-button  size="small" @click="IDCard(scope.row)"><i class="fa fa-id-card"></i> {{$t('IDCARD')}}</el-button>
                  </el-button-group>
              </template>
          </el-table-column>

          <el-table-column
            label=""
            min-width="220"
            align="center"
            class="actions">

            <template slot-scope="scope">
              <el-tooltip  v-if="isAllowed('save', 'attendance/absence')" :content="$t('MARKABSENCE')" placement="top">
                <el-button type="text" @click="markAbsence(scope.row)"><i class="fa fa-user-times"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="isAllowed('send', 'report/message')" :content="$t('SENDMESSAGE')" placement="top">
                <el-button type="text" @click="showMessageModal(scope.row)"><i class="fa fa-comment"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="isAllowed('save_tag')" :content="$t('ISSUEATTENDANCETAG')" placement="top">
                <el-button  type="text" v-bind:class="[scope.row.AssignedTagID!=null ? 'text-success' : '']" @click="showScanModal(scope.row)" ><i class="fa fa-wifi"></i></el-button>
              </el-tooltip>
              <el-tooltip v-if="isAllowed('save')"  :content="$t('EDITSTUDENT')" placement="top">
                <el-button type="text" @click="$router.push({path:'/school/student/'+scope.row.StudentID})"><i class="fa fa-pencil"></i></el-button>
              </el-tooltip>
              <el-tooltip :disabled="scope.row.AssignmentStatus!=null ? true : false" :content="listStudents[scope.$index].Status==0 ? $t('DEACTIVATESTUDENT') : $t('ACTIVATESTUDENT')" placement="top">
                <el-popover
                  trigger="manual"
                  placement="left"
                  width="160"
                  @show="student=listStudents[scope.$index]"
                  v-model="listStudents[scope.$index].Deleted">
                  <p> {{$t('AREYOUSUREYOUWANTTO') + ' '}}{{listStudents[scope.$index].Status==0 ? $t('DEACTIVATETHISSTUDENT') : $t('RESTORETHISSTUDENT')}}</p>
                  <div style="text-align: right; margin: 0">
                    <el-button size="mini" type="text" @click="listStudents[scope.$index].Deleted = false">{{$t('CANCEL')}}</el-button>
                    <el-button type="primary" size="mini" @click="toggleStatus(scope.$index)">{{$t('CONFIRM')}}</el-button>
                  </div>
                  <el-button v-if="isAllowed('delete')" :disabled="scope.row.AssignmentStatus!=null" style="margin-left:10px" type="text" @click="checkRoute(scope.$index)" slot="reference"><i class="fa" :class="[scope.row.DeletedAT!=null ? 'fa-undo' : 'fa-times']"></i> </el-button>
                </el-popover>
              </el-tooltip>                                                                                                 
            </template>
          </el-table-column>
        </el-table>

          <div style="padding:10px" ref="pagination">
            <el-pagination
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="currentPage"
              :page-sizes="[20, 30, 50, 70, 100]"
              :page-size="limit"
              layout="total, sizes, prev, pager, next"
              :total="totalStudents">
            </el-pagination>
          </div>


    </el-card>
<el-tag-dialog :callScan.sync="callScan" :findTag="findTag" :student="student"></el-tag-dialog>
<el-absence-dialog :data="absence" :selected-student="absenceStudent" :server-check="true" :visible.sync="absenceBox"></el-absence-dialog>
<el-message-dialog :visible.sync="messageBox" :showRemove="false" :studentList="messageStudent" :parent="parent"></el-message-dialog>
<el-import-dialog @reCall="getStudents" :visible.sync="dialogImport" :fields="fields" :title="$t('STUDENTS')" uri="student/import" :CSVReader="CSVReader" :CSVFile="CSVFile"></el-import-dialog>

    <el-dialog :title="$t('STUDENTIDCARD')" ref="dialog" :visible.sync="dialogVisible" :before-close="handleDialogClose">
      <div ref="printCard">
          <el-row :gutter="20">
            <el-col :span="printCardWidth" :key="index" v-for="(item, index) in selectedStudents" style="margin-bottom: 20px;">
              <el-row type="flex" style="background-color: #f5c838!important;">
                <el-col class="card-pic" :span="6">
                  <img class="img-circle pic" :src="getAsset(item.ImagePath)"/><br/><br/>
                  <img  style="width:60%; margin-bottom:5px"   :src="getAsset(school.school_logo === 'no-school.png' ? 'adec-print-logo.png' : school.school_logo, 'configuration')"/>
                  <br/>
                  <b>{{school.school_name}}</b>
              </el-col>
                <el-col :span="18">
                  <el-form label-position="top" style="margin: 15px;">
                      <el-row :gutter="10">
                      <el-col :span="12">
                          <el-form-item :label="$t('FIRSTNAME')">
                              <el-input size="small" :placeholder="_FullName({NameEN: item.FirstName_EN, NameAR: item.FirstName_AR})" readonly></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item :label="$t('LASTNAME')">
                              <el-input size="small" :placeholder="_FullName({NameEN: item.LastName_EN, NameAR: item.LastName_AR})" readonly></el-input>
                          </el-form-item>
                      </el-col>
                      </el-row>
                      <el-form-item :label="$t('SCHOOLCONTACT')">
                          <el-input size="small" :placeholder="school.contact_number" readonly></el-input>
                      </el-form-item>
                      <el-row :gutter="10">
                      <el-col :span="12">
                          <el-form-item :label="$t('GRADE')">
                              <el-input size="small" :placeholder="item.Grade" readonly></el-input>
                          </el-form-item>
                      </el-col>
                      <el-col :span="12">
                          <el-form-item :label="$t('CLASS')">
                              <el-input size="small" :placeholder="item.Class" readonly></el-input>
                          </el-form-item>
                      </el-col>
                      </el-row>
                      <el-form-item :label="$t('STUDENTID')">
                          <el-input size="small" :placeholder="item.ExternalStudentID" readonly></el-input>
                      </el-form-item>
                  </el-form>
              </el-col>
              </el-row>
            </el-col>
          </el-row>
      </div>
        <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">{{$t('CANCEL')}}</el-button>
        <el-button type="primary" @click="printCard">{{$t('PRINT')}}</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
  import Vue from 'vue'
  import axios from 'axios'
  import _ from 'lodash'
  import qs from 'qs'
  import AbsenceDialog from '@/components/dialogs/Absence'
  import ImportDialog from '@/components/dialogs/Import'
  import TagDialog from '@/components/dialogs/Tag'
  import MessageDialog from '@/components/dialogs/Message'
  export default {
    components: {'el-absence-dialog': AbsenceDialog, 'el-tag-dialog': TagDialog, 'el-message-dialog': MessageDialog, 'el-import-dialog': ImportDialog},
    data () {
      return {
        students: {},
        absence: {AbsentID: null, StudentID: null, AbsentDate: null, Reason: null, OnlyFromBus: null, Trip: null, FromBMMA: 0},
        absenceStudent: {},
        direction: {0: false, 1: false},
        compose: {Text: null},
        grades: {},
        student: {Deleted: false},
        messageStudent: [],
        absenceFrom: 'Bus',
        lang: 'en',
        printCardWidth: 24,
        indexCheck: 0,
        prevIndex: 0,
        tableHeight: 0,
        limit: 20,
        grade: {},
        totalStudents: 0,
        totalFilter: 0,
        template: 0,
        currentPage: 1,
        visitedPage: [1],
        filter: null,
        active_filter: 'name',
        reset: false,
        FullName: '',
        ExternalStudentID: '',
        RouteID: '',
        Grade: '',
        Class: '',
        Status: '',
        gradeClass: '',
        studentID: '',
        currentRow: null,
        message: null,
        loading: true,
        new_page: false,
        error: false,
        messageBox: false,
        absenceBox: false,
        saving: false,
        dialogVisible: false,
        selectedStudents: [],
        routes: [],
        callScan: false,
        findTag: false,
        school: {},
        parent: {},
        fieldText: {},
        CSVReader: {},
        CSVFile: '',
        dialogImport: false,
        autoSource: null,
        import_data: {}
      }
    },
    computed: {
      listStudents () {
        if (this.students[this.currentPage - 1] === undefined) return
        let students = this.students[this.currentPage - 1]
        return students
      },
      options () {
        let options = [{
          value: 'name',
          label: this.$t('STUDENTNAME')
        }, {
          value: 'route',
          label: this.$t('ROUTENAME')
        }, {
          value: 'id',
          label: this.$t('STUDENTID')
        }, {
          value: 'grade',
          label: this.$t('GRADE')
        }, {
          value: 'status',
          label: this.$t('STATUS')
        }]
        return options
      },
      fields () {
        let fields = [
          {label: this.$t('STUDENTID'), field: 'ExternalStudentID', required: true, format: null},
          {label: this.$t('FIRSTNAME'), field: 'FirstName_EN', required: true, format: null},
          {label: this.$t('FATHERNAME'), field: 'MiddleName', required: true, format: null},
          {label: this.$t('LASTNAME'), field: 'LastName_EN', required: true, format: null},
          {label: this.$t('FIRSTNAME(ARABIC)'), field: 'FirstName_AR', required: false, format: null},
          {label: this.$t('FATHERNAME(ARABIC)'), field: 'MiddleName_AR', required: false, format: null},
          {label: this.$t('LASTNAME(ARABIC)'), field: 'LastName_AR', required: false, format: null},
          {label: this.$t('DATEOFBIRTH'), field: 'DOB', required: true, format: 'date'},
          {label: this.$t('GENDER'), field: 'Gender', required: true, format: null},
          {label: this.$t('NATIONALITY'), field: 'Nationality', required: true, format: null},
          {label: this.$t('GRADE'), field: 'Grade', required: true, format: null},
          {label: this.$t('CLASS'), field: 'Class', required: true, format: null},
          {label: this.$t('HOUSENUMBER'), field: 'HouseNumber', required: true, format: null},
          {label: this.$t('ADDRESS'), field: 'Address', required: false, format: null},
          {label: this.$t('AREA'), field: 'Area', required: false, format: null},
          {label: this.$t('CITY'), field: 'City', required: true, format: null},
          {label: this.$t('STATE'), field: 'State', required: true, format: null},
          {label: this.$t('ZIPCODE'), field: 'ZipCode', required: true, format: null},
          {label: this.$t('SECTOR'), field: 'Sector', required: false, format: null},
          {label: this.$t('ZONE'), field: 'Zone', required: false, format: null},
          {label: this.$t('LAT'), field: 'Lat', required: true, format: null},
          {label: this.$t('LNG'), field: 'Lng', required: true, format: null}
        ]
        return fields
      }
    },
    mounted () {
      this.switchLanguage()
      this.import_data = {folder: this.$route.path.split('/')[2], type: 'import'}
      this.tableHeight = window.innerHeight - (this.$refs.card.$el.children[0].offsetHeight + this.$refs.filter.offsetHeight + this.$refs.pagination.offsetHeight + 53)
      this.$refs.dialog.rendered = true
      let userData = JSON.parse(localStorage.getItem('userData'))
      this.school = {'school_name': userData.school_name, 'contact_number': userData.contact_number, 'school_logo': userData.school_logo}
      this.getStudents()
      this.getGrades()
      this.getRoutes()
    },
    methods: {
      markAbsence (student) {
        this.absence.StudentID = student.StudentID
        this.absenceStudent = _.pick(student, ['StudentID', 'FullName_EN', 'FullName_AR', 'ImagePath'])
        this.absenceBox = true
      },
      currentLang () {
        return localStorage.getItem('lang')
      },
      printAll () {
        let students = this.students[this.currentPage - 1]
        for (let item in students) {
          this.printQueue(students[item])
        }
      },
      removeFilter () {
        this.changeFilter()
        this.active_filter = 'name'
        this.students = {}
        this.getStudents()
      },
      clearInput () {
        this.FullName = this.ExternalStudentID = ''
        this.students = {}
        this.getStudents()
      },
      gradeSelect (item) {
        if (item === '') {
          this.Grade = this.gradeClass = ''
        } else {
        }
      },
      changeFilter () {
        this.FullName = this.ExternalStudentID = this.Grade = this.gradeClass = ''
      },
      toggleStatus (index) {
        let self = this
        let postData = {StudentID: self.listStudents[index].StudentID, Status: self.listStudents[index].Status}
        this.$http.post('/student/delete', postData)
          .then(function (response) {
            self.students = {}
            self.visitedPage = [self.currentPage]
            self.getStudents()
            self.$message({
              message: response.data.error ? self.$t('STUDENTCANNOTBEENDELETED') : self.$t('STUDENTHASBEEN') + ' ' + (response.data.status === '1' ? self.$t('RESTORED') : self.$t('DEACTIVATED')),
              type: response.data.error ? 'error' : 'success',
              showClose: true
            })
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      handleCurrentChange (val) {
        this.currentPage = val
        if (this.visitedPage.indexOf(val) >= 0) return
        this.visitedPage.push(val)
        this.new_page = true
        this.getStudents()
      },
      handleSizeChange (val) {
        this.selectedStudents.length = 0
        this.limit = val
        this.students = {}
        this.currentPage = 1
        this.visitedPage = [1]
        this.loading = true
        this.getStudents()
      },
      getStudents (filter = false) {
        if (filter) {
          this.currentPage = 1
          this.visitedPage = [1]
          this.new_page = true
          this.students = {}
        }
        if (this.students[this.currentPage - 1] !== undefined) return
        if (this.autoSource) this.autoSource.cancel()
        this.autoSource = axios.CancelToken.source()
        let self = this
        this.$http.get('/student?' + qs.stringify(self.bindCurrentFilters()) + '&limit=' + this.limit + '&offset=' + this.limit * (this.currentPage - 1), {cancelToken: this.autoSource.token})
          .then(function (response) {
            self.autoSource = null
            for (let student in response.data.students) {
              response.data.students[student].Deleted = false
            }
            Vue.set(self.students, self.currentPage - 1, response.data.students)
            self.new_page = self.loading = false
            self.totalStudents = response.data.total
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      bindCurrentFilters () {
        let data = {filters: []}
        switch (this.active_filter) {
          case 'name': data.filters['FullName'] = this.FullName
            break
          case 'route': data.filters['RouteID'] = this.RouteID
            break
          case 'id': data.filters['ExternalStudentID'] = this.ExternalStudentID
            break
          case 'grade': data.filters['Grade'] = this.Grade.Name
            if (this.gradeClass !== '') data.filters['Class'] = this.gradeClass
            break
          case 'status': data.filters['Status'] = this.Status
            break
        }
        return data
      },
      getGrades () {
        let self = this
        this.$http.get('/configuration/grade')
          .then(function (response) {
            self.grades = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      getRoutes () {
        let self = this
        this.$http.get('/route?ref=student')
          .then(function (response) {
            self.routes = response.data
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      newStudent () {
        this.$router.push('/school/student/create')
      },
      isOnQueue (item) {
        if (this.selectedStudents.indexOf(item) >= 0) return true
        return false
      },
      printQueue (item) {
        if (this.selectedStudents.indexOf(item) >= 0) return this.selectedStudents.splice(this.selectedStudents.indexOf(item), 1)
        this.selectedStudents.push(item)
      },
      IDCard (item) {
        this.printCardWidth = 24
        this.template = 3
        this.selectedStudents = []
        this.selectedStudents.push(item)
        this.dialogVisible = true
      },
      printCard () {
        this.dialogVisible = false
        this.printCardWidth = 12
        this.$nextTick(function () {
          let card = this.$refs.printCard.innerHTML
          let w = window.open()
          w.document.write('<!DOCTYPE html><html><head><meta http-equiv="Content-Type" content="text/html; charset=utf-8" /><title>Print it!</title><link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/element-ui/1.4.9/theme-default/index.css"><style>.el-row .el-row--flex {background-color: rgb(245, 200, 56) !important; width: auto;}.el-button-group {display: inline-flex;}.card-pic {background-color: #4b4b4b !important;padding-top: 10px;text-align: center;}.card-pic .pic {width: 75%;border-radius: 50%;margin: 10px;border: 4px solid #f5ca40;-webkit-box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);-moz-box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);}label.el-form-item__label {font-weight: normal;}form{margin: 10px;}.el-form--label-top .el-form-item__label{padding: 0 0 0 0;}.el-form-item {margin-bottom: 0px;}</style></head><body>')
          let s = w.document.createElement('script')
          s.type = 'text/javascript'
          s.src = require('../../assets/js/print.js')
          w.document.write(card)
          w.document.body.appendChild(s)
          w.document.write('</body></html>')
          w.setTimeout(function () {
            w.print()
            w.close()
          }, 1000)
        })
      },
      handleDialogClose (done) {
        this.dialogVisible = false
      },
      checkRoute (index) {
        let self = this
        self.listStudents[self.prevIndex].Deleted = false
        if (self.indexCheck === self.listStudents[index].StudentID) return
        this.$http.get('/route/check?Type=Student&ID=' + self.listStudents[index].StudentID)
          .then(function (response) {
            let result = response.data
            self.prevIndex = index
            if (result.TourID !== undefined) {
              self.listStudents[index].Deleted = false
              self.indexCheck = self.listStudents[index].StudentID
              return self.$message({
                message: self.$t('STUDENTHASBEENASSIGNEDTOROUTE'),
                type: 'warning',
                showClose: true,
                onClose: function () {
                  self.indexCheck = null
                }
              })
            }
            self.listStudents[index].Deleted = true
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      querySearch (queryString, cb) {
        let self = this
        if (self.FullName === null) return
        if (self.autoSource) self.autoSource.cancel()
        let result = self.findStudent(queryString)
        if (queryString.length < 3) return
        result.then(function (response) {
          self.autoSource = null
          cb(!response.data ? [] : response.data)
        }).catch(function () {
        })
      },
      findStudent (queryString) {
        this.autoSource = axios.CancelToken.source()
        return this.$http.get('/student/find?term=' + queryString + '&from=route', {cancelToken: this.autoSource.token})
      },
      searchStudent () {
        let self = this
        let term = self.FullName
        if (self.ExternalStudentID != null) term = self.ExternalStudentID
        if (self.autoSource) self.autoSource.cancel()
        self.findStudent(term)
          .then(function (response) {
            for (let student in response.data.students) {
              response.data.students[student].Deleted = false
            }
            Vue.set(self.students, self.currentPage - 1, response.data.students)
            self.new_page = self.loading = false
            self.totalStudents = response.data.total
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      manageStudent (data) {
        let student = data.student
        this.$router.push({path: '/school/student/' + student.StudentID})
      },
      showScanModal (student, findTag = false) {
        this.callScan = true
        this.findTag = findTag
        this.student = student
      },
      showMessageModal (student) {
        let self = this
        self.messageStudent = []
        this.$http.get('/student/relation?StudentID=' + student.StudentID)
          .then(function (response) {
            if (_.isEmpty(response.data)) {
              return self.$message({
                message: self.$t('STUDENTHASNOGUARDIAN'),
                type: 'warning',
                showClose: true
              })
            } else {
              self.messageStudent.push(student)
              self.parent = response.data
              self.messageBox = true
            }
          })
          .catch(function (error) {
            console.log(error)
          })
      },
      uploadedFile (response, file, fileList) {
        if (response.error) {
          return this.$message({
            message: response.error,
            type: 'error',
            showClose: true
          })
        }
        this.CSVReader = response.fields
        this.CSVFile = response.file_name
        this.dialogImport = true
      },
      changedFilter (val) {
        if (val === null) return
        this.active_filter = val
        this.filter = null
        let load = false
        if (this.FullName !== '' | this.RouteID !== '' | this.ExternalStudentID !== '' || this.Grade !== '' || this.Status !== '') load = true
        if (load) {
          this.FullName = this.RouteID = this.ExternalStudentID = this.Grade = this.gradeClass = this.Status = ''
          this.getStudents(true)
        }
      },
      getSchoolPhoto (image) {
        if (image === undefined) return this.BASEURL + 'uploads/thumbnails/adec-print-logo.png'
        image = image !== null && image !== '' ? image : 'adec-print-logo.png'
        return this.BASEURL + 'uploads/thumbnails/' + image
      },
      handleClick (command) {
        switch (command) {
          case 'print':
            this.printAll()
            break
          case 'tag':
            this.showScanModal({AssignedTagID: null}, true)
            break
        }
      }
    }
  }
</script>

<style>
    #student-list .el-dropdown-menu__item .el-upload {text-align: left;width: 100%;}
    #student-list .el-button-group {display: inline-flex;}
    #student-list .card-pic {
        background-color: #4b4b4b !important;
        padding-top: 10px;
        text-align: center;
    }
    #student-list .card-pic .pic {
        width: 75%;
        border-radius: 50%;
        margin: 10px;
        border: 4px solid #f5ca40;
        -webkit-box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);
        -moz-box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);
        box-shadow: 0px 0px 142px -37px rgba(0, 0, 0, 0.75);
    }
    #student-list label.el-form-item__label {
        font-weight: normal;
    }
    #student-list form{margin: 10px;}
    #student-list .el-form--label-top .el-form-item__label{padding: 0 0 0 0;}
    #student-list .el-form-item {margin-bottom: 0px;}
    #student-list .clearfix .el-button-group {float:right}
    #rtl #student-list .clearfix .el-button-group {float:left}
    .tooltip {margin-top: 0 px}
</style>



// WEBPACK FOOTER //
// Student.vue?025f0ac5